const initialRecurringRulesState = {
  recurringRules: {
    loading: false,
    data: [],
    error: '',
    totalNo: 0,
  },
  createRecurringRule: {
    loading: false,
    data: null,
    error: '',
  },
  updateRecurringRule: {
    loading: false,
    data: null,
    error: '',
  },
  deleteRecurringRule: {
    loading: false,
    data: null,
    error: '',
  },
  automatedOrders: {
    loading: false,
    data: [],
    error: '',
    totalNo: 0,
  },
};

export { initialRecurringRulesState };
